import { Renderable } from "../renderable/Renderable";
import { BufferGeometry, Group } from "three";
import { modelToAbsolutePath, modelPool } from "@modules/model";
export class MeshGroupRenderable extends Renderable {
    constructor() {
        super(...arguments);
        this.type = MeshGroupRenderable.typestatic;
    }
    destroy() { }
    getGeometry() {
        if (this.group === undefined)
            return undefined;
        return {
            geometry: new BufferGeometry(), // TODO: UGLY, just done to please the compiler, needs better design!!
            mesh: this.group
        };
    }
    setVisible(_visible) { }
    updateFacet(_facet) {
        if (this.facet === undefined) {
            this.group = new Group();
            const model = modelPool.getModelOrThrow(this.owner.modelUID);
            this.group.name = model.getName();
            this.group.userData = {
                path: modelToAbsolutePath(model)
            };
            const parentRoomModel = model.getRoom();
            if (parentRoomModel !== undefined) {
                const room = this.owner.renderer.getRootNodeForRoom(parentRoomModel.getUID());
                room.add(this.group);
            }
        }
    }
    updateTransform() {
        if (this.group === undefined)
            throw new Error("We expect this.instance to be defined.");
        this.group.position.copy(this.owner.worldPosition);
        this.group.quaternion.copy(this.owner.worldOrientation);
        this.group.scale.copy(this.owner.worldScale);
        this.group.matrixWorldNeedsUpdate = true;
    }
}
MeshGroupRenderable.typestatic = "Primitive";
